// DonationsModal.jsx
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Flex,
  Box,
  useColorMode,
  Text,
  useMediaQuery,
  Grid,
  Image,
  Link,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faGift } from '@fortawesome/free-solid-svg-icons';
import { BtcPayForm } from '../buttons';

const supportersData = [
  { username: 'PlebUnderground', link: 'https://x.com/PlebUnderground' },
  { username: 'illiteratewithd', link: 'https://x.com/illiteratewithd' },
  { username: 'Meditation_Man', link: 'https://x.com/Meditation_Man' },
  { username: 'honesthodl', link: 'https://x.com/honesthodl' },
  { username: 'brian_trollz', link: 'https://x.com/brian_trollz' },
  { username: 'rwawoe', link: 'https://x.com/rwawoe' },
  { username: 'HumbleBitcoiner', link: 'https://x.com/HumbleBitcoiner' },
  { username: 'S0cratesz', link: 'https://x.com/S0cratesz' },
  { username: 'kavanhak', link: 'https://x.com/kavanhak' },
  { username: 'Florida_Btc', link: 'https://x.com/Florida_Btc' },
  { username: 'Train_Johnson', link: 'https://x.com/Train_Johnson' },
];

const Supporter = ({ link, username, imageKey }) => {
  // Use custom image for honesthodl
  const imageSrc = username === 'honesthodl' 
    ? 'https://pbs.twimg.com/profile_images/1801499602333360128/56KJXp3e_400x400.jpg'
    : `https://unavatar.io/twitter/${username}`;
  
  return (
    <Link href={link} target={'_blank'}>
      <Image
        key={imageKey}
        borderRadius={40}
        border={'2px'}
        borderColor={'gray.700'}
        objectFit="cover"
        src={imageSrc}
        alt={`@${username}`}
        fallbackSrc="https://www.gravatar.com/avatar/?d=mp&s=200"
        width="100%"
        height="100%"
      />
    </Link>
  );
};

const SupportersGrid = ({ supporters, imageKey }) => (
  <Grid templateColumns="repeat(5, 1fr)" gap={5}>
    {supporters.slice(0, 10).map((supporter, index) => (
      <Supporter key={index} {...supporter} imageKey={imageKey} />
    ))}
  </Grid>
);

export const DonationsModal = ({ isOpen, onClose, donateForm }) => {
  const { colorMode } = useColorMode();
  const bgColor = colorMode === 'dark' ? '#121212' : '#ffffff';
  const borderColor = colorMode === 'dark' ? '#ffffff' : '#121212';
  const [isSmallScreen] = useMediaQuery('(max-width: 768px)');
  const [imageKey, setImageKey] = React.useState(0);

  React.useEffect(() => {
    if (isOpen) {
      // Force images to reload when modal opens
      setImageKey(prev => prev + 1);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: "2xl", md: "2xl" }}>
      <ModalOverlay backgroundColor="rgba(16, 22, 26, 0.9)" />
      <ModalContent bg={bgColor} pb={6} borderWidth="2px" borderStyle="solid" borderColor={borderColor} borderRadius="6px" overflow="hidden">
        <ModalHeader><FontAwesomeIcon icon={faGift} /> &nbsp;Help Support TimechainStats</ModalHeader>
        <ModalCloseButton
          _hover={{
            bg: 'gray.500',
          }}
          _focus={{
            boxShadow: '0 0 0 1px rgba(66, 153, 225, 0.6)',
          }}
        />
        <ModalBody>
          <Flex direction={isSmallScreen ? "column" : "row"} gap={12}>
            <Box flex="2">
              <Text>
                Contribute to TimechainStats.com with BTC tips.
                Your support will help keep this website running.
                On-chain or Lightning Network tips accepted.
              </Text>
              <Text mt={5} color={'#888'}>
                Questions? Contact <Link href='https://x.com/TimechainStats' target={'_blank'} textDecoration={'underline'}>@TimechainStats</Link> on Twitter.
              </Text>
              <Text mt={7} mb={3} fontSize={'18px'} fontWeight={'bold'}>
                <FontAwesomeIcon icon={faAward} size={'lg'} /> &nbsp;Top Supporters
                <Link color={colorMode === 'dark' ? 'orange' : 'blue'} ml={2} fontSize="xs" onClick={donateForm}>VIEW ALL</Link>
              </Text>
              <SupportersGrid supporters={supportersData} imageKey={imageKey} />
            </Box>
            <Box flex="1">
              <Text textAlign={'center'} mb={3} fontWeight={'bold'}>Donate Here</Text>
              <Text textAlign={'center'}><BtcPayForm onClose={onClose} /></Text>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};